export default function (amount,symbol) {
	if(amount !== null){
		if(symbol){
			return symbol+`${amount.toFixed(2)}`
		}
		else{
			return `$${amount.toFixed(2)}`
		}
		
	}
}
